<div class="milestone-wrapper m-t-5">
  <div class="details dis-flex flex-sb">
    <div class="left-side dis-flex flex-col">
      <div class="tags dis-flex">
        <p-chip
          class="b3 radius-8 status-chip not-started"
          *ngIf="milestoneList?.status == '1'"
          label="Not started"
        />
        <p-chip
          class="b3 radius-8 status-chip ongoing"
          *ngIf="milestoneList?.status == '2'"
          label="Ongoing"
        />
        <p-chip
          class="b3 radius-8 status-chip completed"
          *ngIf="milestoneList?.status == '3'"
          label="Completed"
        />
        <p-chip
          class="b3 radius-8 status-chip delayed"
          *ngIf="milestoneList?.status == '4'"
          label="Delayed"
        />
        <p-chip
          class="b3 radius-8 status-chip terminated"
          *ngIf="milestoneList?.status == '5'"
          label="Terminated"
        />
      </div>
      <div class="content-title dis-flex flex-m m-t-15">
        <p-avatar label="M" class="outcome-type m-r-10 p-avatar-square" />
        <p class="b1 m-b-0 text-80">
          {{ milestoneList?.value }}
        </p>
      </div>
      <div class="dates-wrapper dis-flex m-t-20 m-b-5">
        <div class="start-date m-r-40">
          <p class="caption font-medium text-60 m-b-0">Start Date</p>
          <div class="dis-flex flex-m lh-1-0">
            <ng-icon name="hugeCalendar03" size="18" />
            <p class="caption text-70 m-b-0 m-l-5 p-t-3">
              {{ milestoneList?.start_date | dateFormatPipe }}
            </p>
          </div>
        </div>
        <div class="planned-end-date m-r-40">
          <p class="caption font-medium text-60 m-b-0">Planned End Date</p>
          <div class="dis-flex flex-m lh-1-0">
            <ng-icon name="hugeCalendar03" size="18" />
            <p class="caption text-70 m-b-0 m-l-5 p-t-3">
              {{ milestoneList?.plan_end_date | dateFormatPipe }}
            </p>
          </div>
        </div>
        <div class="actual-end-date m-r-40">
          <p class="caption font-medium text-60 m-b-0">Actual End Date</p>
          <div class="dis-flex flex-m lh-1-0">
            <ng-icon name="hugeCalendar03" size="18" />
            <p class="caption text-70 m-b-0 m-l-5 p-t-3">
              {{ milestoneList?.actual_end_date | dateFormatPipe }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="right-side dis-flex flex-col flex-sb"
      *ngIf="milestoneList?.status != '5'"
    >
      <div class="action-items milestone-items p-t-4 text-right" #actionItem>
        <button
          class="icon-only-btn"
          [ngbPopover]="actionItemsMenu"
          *ngIf="
            (timeline?.plan_end | isPlanningPhase) &&
            (milestoneList?.accountable | canViewActionItem)
          "
        >
          <ng-icon
            class="icon-hover-primary"
            ngbTooltip="Action Items"
            name="hugeMoreVerticalCircle01"
          />
        </button>
        <ng-template #actionItemsMenu>
          <div class="action-item-list">
            <a
              type="button"
              class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
              (click)="updateMilestone()"
            >
              <ng-icon class="text-80 lh-1-0" name="hugeEdit02" size="18" />
              <span class="b2 text-80 m-l-10">Edit / Update</span>
            </a>
            <a
              type="button"
              class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
              (click)="addDependency()"
            >
              <ng-icon class="text-80 lh-1-0" name="hugeUserAdd02" size="18" />
              <span class="b2 text-80 m-l-10">Add Dependency</span>
            </a>
            <a
              type="button"
              (click)="openTerminateModal()"
              class="dis-flex danger-action-item p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
            >
              <ng-icon class="text-80 lh-1-0" name="hugeDelete02" size="18" />
              <span class="b2 text-80 m-l-10">Terminate</span>
            </a>
          </div>
        </ng-template>
      </div>
      <p
        class="caption text-60 font-medium m-b-5"
        *ngIf="milestoneList?.dependencies?.length"
      >
        Dependency
      </p>
      <div
        class="dependency dis-flex"
        *ngIf="milestoneList?.dependencies?.length"
      >
        <div
          class="m-r-20"
          *ngFor="let userList of milestoneList?.dependencies"
        >
          <div class="dis-flex flex-m m-b-4">
            <p-avatar
              class="outcome-dependency-avatar m-r-5 p-avatar-square"
              [image]="userList?.user?.avatar || getDefaultAvatar()"
            />
            <div class="dependency-person">
              <p class="b3 font-medium text-100 m-b-0 lh-1-5">
                {{ userList?.user?.name }}
              </p>
              <p class="b3 text-60 m-b-0 lh-1-5">
                {{ userList?.user?.designation }}
              </p>
            </div>
          </div>
          <div>
            <p-chip
              class="b3 radius-8 status-chip not-started"
              *ngIf="
                userList?.status == '1' 
              "
              label="Not started"
            />
            <p-chip
              class="b3 radius-8 status-chip ongoing"
              *ngIf="userList?.status == '2'"
              label="Ongoing"
            />
            <p-chip
              class="b3 radius-8 status-chip completed"
              *ngIf="userList?.status == '3'"
              label="Completed"
            />
            <p-chip
              class="b3 radius-8 status-chip delayed"
              *ngIf="userList?.status == '4'"
              label="Delayed"
            />
            <p-chip
              class="b3 radius-8 status-chip terminated"
              *ngIf="userList?.status == '5'"
              label="Terminated"
            />
          </div>
        </div>
        <!-- <div class="m-r-20">
          <div class="dis-flex flex-m m-b-4">
            <p-avatar
              class="outcome-dependency-avatar m-r-5"
              image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
              shape="circle"
            />
            <div class="dependency-person">
              <p class="b3 font-medium text-100 m-b-0 lh-1-5">Romy Murray</p>
              <p class="b3 text-60 m-b-0 lh-1-5">CRO Associate</p>
            </div>
          </div>
          <div>
            <p-chip
              class="b3 radius-8 status-chip ongoing text-10"
              label="Ongoing"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Terminate ?"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="isOpenTerminateModal"
  [style]="{ width: '30rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <div class="dis-flex flex-col">
      <p class="b2 m-b-0 text-70">
        Are you sure, you want
        <span class="font-medium text-80">terminate the milestone</span>
        ?
      </p>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10" (click)="closeTerminateModal()">
      No
    </button>
    <button class="btn primary wd-100px" (click)="terminateMileStone()">
      Yes
    </button>
  </div>
</p-dialog>

<!-- Dependency Modal -->
<p-dialog
  header="Add Dependency"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '50rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-50">
    <div class="dis-flex gap-3">
      <div class="dis-flex flex-col wd-50">
        <label for="username" class="b2 font-medium m-b-5 text-80">Group</label>
        <!-- <p-multiSelect
          [options]="overAllGroupData"
          [(ngModel)]="selectedGroups"
          optionLabel="name"
          placeholder="Select Groups"
          display="chip"
          filter="true"
          (onFilter)="onOverAllSearchChange($event)"
          (onChange)="onGroupDataChange()"
          [overlayOptions]="helperService.getOverlayOptions()"
        >
        </p-multiSelect> -->

        <p-dropdown
          [options]="overAllGroupData"
          [(ngModel)]="selectedGroup"
          optionLabel="name"
          placeholder="Select Group"
          filter="true"
          (onFilter)="onOverAllSearchChange($event)"
          (onChange)="onGroupDataChange()"
          [overlayOptions]="helperService.getOverlayOptions()"
        ></p-dropdown>
      </div>
      <div class="dis-flex flex-col wd-50" *ngIf="selectedGroup">
        <label for="email" class="b2 font-medium m-b-5 text-80"
          >Team Member</label
        >
        <!-- <p-multiSelect
          optionLabel="name"
          [options]="groupMemberList"
          [(ngModel)]="selectedGroupsMember"
          filter="true"
          display="chip"
          appendTo="body"
          (onFilter)="onGroupMemberSearchChange($event)"
          placeholder="Select"
        >
      </p-multiSelect> -->
        <p-dropdown
          optionLabel="name"
          [options]="groupMemberList"
          [(ngModel)]="selectedGroupMember"
          filter="true"
          (onFilter)="onGroupMemberSearchChange($event)"
          (onChange)="onGroupMemberChange($event)"
          placeholder="Select"
        ></p-dropdown>
      </div>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button
      class="btn outline wd-100px m-r-10"
      (click)="closeDependeciesModal()"
    >
      Cancel
    </button>
    <button class="btn primary wd-100px" (click)="addDepencies()">Add</button>
  </div>
</p-dialog>

<!-- Update Milestone Modal -->
<p-dialog
  header="Edit / Update Milestone"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="dependencyModal"
  [style]="{ width: '50rem' }"
>
  <!-- <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-50">
    <div class="dis-flex flex-col">
      <div class="dis-flex flex-col w-full m-b-20">
        <label for="username" class="b2 font-medium m-b-5 text-80"
          >Quarterly Outcome</label
        >
        <input type="text" [disabled]="true" />
      </div>
      <div class="dis-flex flex-col w-full m-b-20">
        <label for="username" class="b2 font-medium m-b-5 text-80"
          >Milestone Title <span class="mandatory">*</span></label
        >
        <input type="text" />
      </div>
    </div>
    <div class="dis-flex gap-3">
      <div class="dis-flex flex-col wd-50">
        <label for="username" class="b2 font-medium m-b-5 text-80"
          >Start Date</label
        >
        <p-calendar
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="templatedisplay"
        >
          <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
            <ng-icon
              class="calendar-icon"
              name="hugeCalendar03"
              (click)="clickCallBack($event)"
            />
          </ng-template>
        </p-calendar>
      </div>
      <div class="dis-flex flex-col wd-50">
        <label for="username" class="b2 font-medium m-b-5 text-80"
          >Planned End Date</label
        >
        <p-calendar
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="templatedisplay"
        >
          <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
            <ng-icon
              class="calendar-icon"
              name="hugeCalendar03"
              (click)="clickCallBack($event)"
            />
          </ng-template>
        </p-calendar>
      </div>
      <div class="dis-flex flex-col wd-50">
        <label for="username" class="b2 font-medium m-b-5 text-80"
          >Actual End Date</label
        >
        <p-calendar
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="templatedisplay"
        >
          <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
            <ng-icon
              class="calendar-icon"
              name="hugeCalendar03"
              (click)="clickCallBack($event)"
            />
          </ng-template>
        </p-calendar>
      </div>
    </div>
  </div>
  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button class="btn outline wd-100px m-r-10">Cancel</button>
    <button class="btn primary wd-100px">Update</button>
  </div> -->

  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-50">
      <div class="dis-flex flex-col">
        <div class="dis-flex flex-col w-full m-b-20">
          <label for="username" class="b2 font-medium m-b-5 text-80">
            STO
          </label>
          <input type="text" formControlName="quarterlyOutcome" />
        </div>
        <div class="dis-flex flex-col w-full m-b-20">
          <label for="milestoneTitle" class="b2 font-medium m-b-5 text-80">
            Milestone Title <span class="mandatory">*</span>
          </label>
          <input type="text" formControlName="milestoneTitle" />
        </div>
      </div>
      <div class="dis-flex gap-3">
        <div class="dis-flex flex-col wd-50">
          <label for="start_date" class="b2 font-medium m-b-5 text-80">
            Start Date
          </label>
          <p-calendar
            [iconDisplay]="'input'"
            [showIcon]="true"
            [dateFormat]="'dd-mm-yy'"
            formControlName="start_date"
            inputId="templatedisplay"
            appendTo="body"
          >
            <ng-template
              pTemplate="inputicon"
              let-clickCallBack="clickCallBack"
            >
              <ng-icon
                class="calendar-icon"
                name="hugeCalendar03"
                (click)="clickCallBack($event)"
              ></ng-icon>
            </ng-template>
          </p-calendar>
        </div>
        <div class="dis-flex flex-col wd-50">
          <label for="plan_end_date" class="b2 font-medium m-b-5 text-80">
            Planned End Date
          </label>
          <p-calendar
            [iconDisplay]="'input'"
            [showIcon]="true"
            [dateFormat]="'dd-mm-yy'"
            formControlName="plan_end_date"
            inputId="templatedisplay"
            appendTo="body"
          >
            <ng-template
              pTemplate="inputicon"
              let-clickCallBack="clickCallBack"
            >
              <ng-icon
                class="calendar-icon"
                name="hugeCalendar03"
                (click)="clickCallBack($event)"
              ></ng-icon>
            </ng-template>
          </p-calendar>
        </div>
        <div class="dis-flex flex-col wd-50">
          <label for="actual_end_date" class="b2 font-medium m-b-5 text-80">
            Actual End Date
          </label>
          <p-calendar
            [iconDisplay]="'input'"
            [showIcon]="true"
            [dateFormat]="'dd-mm-yy'"
            formControlName="actual_end_date"
            inputId="templatedisplay"
            appendTo="body"
          >
            <ng-template
              pTemplate="inputicon"
              let-clickCallBack="clickCallBack"
            >
              <ng-icon
                class="calendar-icon"
                name="hugeCalendar03"
                (click)="clickCallBack($event)"
              ></ng-icon>
            </ng-template>
          </p-calendar>
        </div>
      </div>
      <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
        <button
          type="button"
          class="btn outline wd-100px m-r-10"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn primary wd-100px"
          (submit)="onSubmit()"
        >
          Update
        </button>
      </div>
    </div>
  </form>
</p-dialog>
